import { request } from '@/utils/request';

/** 
 * 查询机构列表
 * 接口文档：https://yapi.cai-inc.com/project/1734/interface/api/184470
*/
export function fetchInstitutions (params) {
  return request('/api/workbench/subscription/institutions', {
    params,
  });
}

/** 
 * 查询机构订阅树
 * 接口文档：https://yapi.cai-inc.com/project/1734/interface/api/184934
*/
export function fetchInstitutionSubscriptionTree (params) {
  const { userType, ...rest } = params || {};

  return request(`/api/workbench/subscription/institution/product/func/tree/${userType}`, {
    params: rest,
  });
}

/**
 * 查询机构已经订阅功能
 * @param {any} params 
 * @returns 
 */
export function fetchInstitutionHasOutlineTree (params) {
  return request('/api/workbench/subscription/institution/subscribe/functions', {
    params,
  });
}

/** 
 * 订阅机构
 * 接口文档：https://yapi.cai-inc.com/project/1734/interface/api/184534
*/
export function subscribeInstitution (params) {
  return request('/api/workbench/subscription/institution/subscribe/functions', {
    method: 'post',
    data: params,
  });
}

/**
 * 查询租户可订阅功能列表
 * @param {Object} params 
 * @returns 
 */
export function fetchTenantOutline (params) {
  const { userType, ...rest } = params;
  return request(`/api/workbench/subscription/tenant/product/func/tree/${userType}`, {
    params: rest,
  });
}

/**
 * 获取全量用户类别
 * @param {Object} params 
 * @returns 
 */
export function fetchUserTypes (params) {
  return request('/api/workbench/common/userTypes', {
    params,
  });
}
/**
 * 获取租户订购功能
 * @param {Object} params 
 * @returns 
 */
export function fetchTenantHasOutline (params) {
  return request('/api/workbench/subscription/tenant/subscribe/functions', {
    params,
  });
}
/**
 * 提交组合功能
 * @param {Object} params 
 * @returns 
 */
export function subTenantOutline (params) {
  return request('/api/workbench/subscription/tenant/subscribe/functions', {
    method: 'post',
    data: params,
  });
}

/**
 * 批量提交租户功能
 * @param {any} params 
 * @returns 
 */
export function subBatchTenantOutline (params) {
  return request('/api/workbench/subscription/batch/tenant/subscribe/functions', {
    method: 'post',
    data: params,
  });
}

/**
 * 关联岗位页面-查询初始化岗位菜单树
 * @param {Object} params 
 * @returns 
 */
export function fetchPositionMenuTreesOfInit (params) {
  return request('/api/privileges/getRoleTreeByOperator', {
    method: 'post',
    data: params,
  });
}

/**
 * 租户批量取消功能
 * @param {any} params 
 * @returns 
 */
export function subBatchTenantCancelOutline (params) {
  return request('/api/workbench/subscription/batch/tenant/unsubscribe/functions', {
    method: 'post',
    data: params,
  });
}

/**
 * 关联岗位页面-编辑时候用到的全量菜单树
 * @param {Object} params 
 * @returns 
 */
export function fetchAllPositionMenuTrees (params) {
  return request('/api/privileges/getRoleTree4User', {
    method: 'post',
    data: params,
  });
}

/**
 * 组合可以选择菜单
 * @param {any} params 
 * @returns 
 */
export function fetchTenantMenu (params) {
  return request('/api/workbench/subscription/tenant/subscribed/menus', {
    params,
  });
}

/**
 * 关联岗位页面-保存权限
 * @param {Object} params 
 * @returns 
 */
export function savePermission (params) {
  return request('/api/users/saveUserFs', {
    method: 'post',
    data: params,
  });
}

/**
 * 获取租户已有菜单
 * @param {any} params 
 * @returns 
 */
export function fetchTenantHasMenu (params) {
  return request('/api/workbench/subscription/tenant/exclude/menus', {
    params,
  });
}

/**
 * 提交租户排除菜单
 * @param {any} params 
 * @returns 
 */
export function subTenantNoHasMenu (params) {
  return request('/api/workbench/subscription/tenant/exclude/menus', {
    method: 'post',
    data: params,
  });
}
/**
 * 批量关联菜单
 * @param {any} params 
 * @returns 
 */
export function subBatchTenantMenu (params) {
  return request('/api/workbench/subscription/batch/tenant/include/menus', {
    method: 'post',
    data: params,
  });
}
/**
 * 批量取消关联菜单
 * @param {any} params 
 * @returns 
 */
export function subBatchTenantCancelMenu (params) {
  return request('/api/workbench/subscription/batch/tenant/exclude/menus', {
    method: 'post',
    data: params,
  });
}

/**
 * 获取机构可以使用的全量菜单
 * @param {any} params 
 * @returns 
 */
export function fetchInstitutionCanUserMenu (params) {
  return request('/api/workbench/subscription/institution/subscribed/menus', {
    params,
  });
}
/**
 * 提交机构移除菜单
 * @param {any} params 
 * @returns 
 */
export function subInstitutionCancelMenu (params) {
  return request('/api/workbench/subscription/institution/exclude/menus', {
    method: 'post',
    data: params,
  });
}
/**
 * 机构移除菜单
 * @param {any} params 
 * @returns 
 */
export function fetchInstitutionCancelMenu (params) {
  return request('/api/workbench/subscription/institution/exclude/menus', {
    params,
  });
}
/**
 * 机构显示菜单已有数据
 * @param {any} params 
 * @returns 
 */
export function fetchInstitutionHasShowMenu (params) {
  return request('/api/workbench/subscription/institution/visible/menus', {
    params,
  });
}
/**
 * 租户显示菜单已有数据
 * @param {any} params 
 * @returns 
 */
export function fetchTenantHasShowMenu (params) {
  return request('/api/workbench/subscription/tenant/visible/menus', {
    params,
  });
}

export function subTenantMissCheckOutline (params) {
  return request('/api/workbench/subscription/missing/dependency/applications', {
    method: 'post',
    data: params,
  });
}

// 校验租户订阅的功能树
export function checkTenantTree (params) {
  return request('/api/workbench/subscription/tenant/subscribe/functions/check', {
    params,
  });
}
// 校验机构订阅的功能树
export function checkInstitutionTree (params) {
  return request('/api/workbench/subscription/institution/subscribe/functions/check', {
    params,
  });
}
// 校验可订阅的租户产品功能树
export function checkUserTenantTree (params) {
  const { user_type } = params || {};
  return request(`/api/workbench/subscription/tenant/product/func/tree/check/${user_type}`, {
    params,
  });
}
// 
// 校验可订阅机构产品功能树
export function checkUserInstitutionTree (params) {
  const { user_type } = params || {};
  return request(`/api/workbench/subscription/institution/product/func/tree/check/${user_type}`, {
    params,
  });
}